// extracted by mini-css-extract-plugin
export default {"labelContainer":"ColumnHeader_labelContainer__MnuRe","tableLabel":"ColumnHeader_tableLabel__DlEFS"};